import { render, staticRenderFns } from "./EDrawerMotivoAula.vue?vue&type=template&id=3f8b6fc2&scoped=true"
import script from "./EDrawerMotivoAula.vue?vue&type=script&lang=js"
export * from "./EDrawerMotivoAula.vue?vue&type=script&lang=js"
import style0 from "./EDrawerMotivoAula.vue?vue&type=style&index=0&id=3f8b6fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8b6fc2",
  null
  
)

export default component.exports